import { ChangeDetectionStrategy, Component, ElementRef, inject, NgZone, OnInit } from "@angular/core";
import { CameraService } from "../../services/camera.service";
import { CesiumMapService } from "../../services/cesium-map.service";
import { ContextMenuService } from "../../services/context-menu.service";

@Component({
    selector: "dtm-map-cesium-map",
    template: `<ng-content></ng-content>
        <dtm-map-cesium-context-menu-wrapper *ngIf="contextMenuService" /> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CameraService],
})
export class CesiumMapComponent implements OnInit {
    private readonly cameraService: CameraService = inject(CameraService);
    private readonly cesiumMapService: CesiumMapService = inject(CesiumMapService);
    private readonly ngZone = inject(NgZone);
    protected readonly contextMenuService = inject(ContextMenuService, { optional: true });

    constructor(private readonly hostElement: ElementRef<HTMLDivElement>) {
        this.ngZone.runOutsideAngular(() => {
            this.cameraService.init(this.cesiumMapService);
        });
    }

    public ngOnInit(): void {
        this.ngZone.runOutsideAngular(() => {
            this.hostElement.nativeElement.appendChild(this.cesiumMapService.getMapContainer());
        });
    }
}
